import { render, staticRenderFns } from "./TouristInfoList.vue?vue&type=template&id=6bc182b8&scoped=true&"
import script from "./TouristInfoList.vue?vue&type=script&lang=js&"
export * from "./TouristInfoList.vue?vue&type=script&lang=js&"
import style0 from "./TouristInfoList.vue?vue&type=style&index=0&id=6bc182b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc182b8",
  null
  
)

export default component.exports